export class OrderPrioritySearchFilter {
    orderId: number;

    constructor() {

    }
}